import bankgiroLogo from "../../../../resources/images/payment.methods/bankgirot-logo.svg";
import sepaLogo from "../../../../resources/images/payment.methods/sepa-logo.svg";
import swishLogo from "../../../../resources/images/payment.methods/swish-logo.svg";
import payexLogo from "../../../../resources/images/payment.methods/payex-logo.svg";
import visamastercardLogo from "../../../../resources/images/payment.methods/visa-mastercard-logo.svg";
import { ReactComponent as YoutubeIcon } from "../../../../resources/images/youtube.svg";
import { ReactComponent as XIcon } from "../../../../resources/images/x.svg";
import { ReactComponent as LinkedinIcon } from "../../../../resources/images/linkedin.svg";
import { ReactComponent as InstagramIcon } from "../../../../resources/images/instagram.svg";

const scrollTo = {
  bottom: {
    behavior: "smooth",
    block: "start"
  },
  top: {
    behavior: "smooth",
    block: "end"
  }
};

const socialMediaLinks = {
  youtube: {
    url: "https://www.youtube.com/@btcxsweden",
    Icon: YoutubeIcon,
    label: "YouTube"
  },
  x: {
    url: "https://x.com/btcxsweden",
    Icon: XIcon,
    label: "X"
  },
  linkedin: {
    url: "https://www.linkedin.com/company/goobitbtcx/",
    Icon: LinkedinIcon,
    label: "LinkedIn"
  },
  instagram: {
    url: "https://www.instagram.com/btcxsweden/",
    Icon: InstagramIcon,
    label: "Instagram"
  }
};

export const paymentMethodsConfig = {
  QuickPayCard: {
    name: "Credit Card"
  },
  SEPA: {
    name: "SEPA",
    logo: sepaLogo
  },
  SWISH: {
    name: "Swish",
    logo: swishLogo
  },
  StripeSwish: {
    name: "StripeSwish",
    logo: swishLogo
  },
  StripeCard: {
    name: "StripeCard",
    logo: visamastercardLogo
  },
  BANKGIRO: {
    name: "Bankgiro",
    logo: bankgiroLogo
  },
  PAYEX: {
    name: "Payex",
    logo: payexLogo
  }
};

export { scrollTo, socialMediaLinks };
